import { styled } from '@mui/material/styles'

import Step from '@mui/material/Step'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'
import StepLabel from '@mui/material/StepLabel'
import MuiStepper from '@mui/material/Stepper'

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.secondary[80].main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: theme.palette.secondary[80].main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: '#2D2D6C80',
    borderRadius: 1,
  },
}))

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: '#2D2D6C80',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...((ownerState.active || ownerState.completed) && {
    backgroundColor: theme.palette.secondary[80].main,
  }),
}))

const ColorlibStepIcon = props => {
  const { active, completed, className, icon } = props

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icon}
    </ColorlibStepIconRoot>
  )
}

const Stepper = ({ step, steps }) => (
  <MuiStepper alternativeLabel activeStep={step} connector={<ColorlibConnector />}>
    {steps.map(({ label, icon }) => (
      <Step key={label}>
        <StepLabel
          StepIconComponent={stepIconProps => <ColorlibStepIcon {...stepIconProps} icon={icon} />}
          sx={{
            '& .MuiStepLabel-label': {
              color: '#2D2D6C80',
              fontWeight: 'bold',
              '&.Mui-active, &.Mui-completed': {
                color: theme => theme.palette.secondary[80].main,
                fontWeight: 'bold',
              },
            },
          }}
        >
          {label}
        </StepLabel>
      </Step>
    ))}
  </MuiStepper>
)

export default Stepper
